module.exports = __webpack_public_path__ + "Roboto-Regular.ba3dcd8903e3d0af5de7.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/bompadre/Documents/angular2/myapp2/font/roboto/Roboto-Regular.woff
// module id = ../../../../../font/roboto/Roboto-Regular.woff
// module chunks = styles